<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

<!-- Tabs Navigation -->
<nav class="tabs-nav">
  <div class="container">
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'articles'"
      (click)="setActiveTab('articles')">
      <i class="pi pi-book"></i> NOS ARTICLES
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'actualites'"
      (click)="setActiveTab('actualites')">
      <i class="pi pi-calendar"></i> ACTUALITÉS
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'faq'"
      (click)="setActiveTab('faq')">
      <i class="pi pi-question-circle"></i> FAQ
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'documents'"
      (click)="setActiveTab('documents')">
      <i class="pi pi-file"></i> DOCUMENTS
    </button>
    <button 
      class="tab-btn" 
      [class.active]="activeTab === 'glossaire'"
      (click)="setActiveTab('glossaire')">
      <i class="pi pi-book"></i> GLOSSAIRE
    </button>
  </div>
</nav>

<!-- Content Section -->
<section class="blog-content">
  <div class="container">
    
    <!-- Articles Tab -->
    <div *ngIf="activeTab === 'articles'" class="articles-grid">
      <article *ngFor="let article of articles" class="article-card">
        <div class="article-image">
          <img [src]="article.image" [alt]="article.title" />
        </div>
        <div class="article-content">
          <span class="article-category">{{ article.category }}</span>
          <h3 class="article-title">{{ article.title }}</h3>
          <p class="article-excerpt">{{ article.excerpt }}</p>
          <a [routerLink]="article.link" class="article-link">Voir Plus</a>
        </div>
      </article>
    </div>

    <!-- FAQ Tab -->
    <div *ngIf="activeTab === 'faq'" class="faq-section">
      <h2>Questions fréquentes sur le changement de son Assurance de Prêt</h2>
      <div class="faq-list">
        <div *ngFor="let item of faqItems" class="faq-item">
          <h3 class="faq-question">{{ item.question }}</h3>
          <p class="faq-answer">{{ item.answer }}</p>
        </div>
      </div>
    </div>

    <!-- Other Tabs (placeholder) -->
    <div *ngIf="activeTab === 'actualites'" class="placeholder-content">
      <i class="pi pi-calendar" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Actualités</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

    <div *ngIf="activeTab === 'documents'" class="placeholder-content">
      <i class="pi pi-file" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Documents</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

    <div *ngIf="activeTab === 'glossaire'" class="placeholder-content">
      <i class="pi pi-book" style="font-size: 4rem; color: #9333ea;"></i>
      <h2>Glossaire</h2>
      <p>Contenu à venir prochainement...</p>
    </div>

  </div>
</section>

</app-page-layout>
